import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import StorePresenter from '../../../../../../../../../presenters/StorePresenter';
import DatePresenter from '../../../../../../../../../presenters/DatePresenter';
import Flash from '../../../../../../../../../components/forms/Flash';
import EditCashbackFormFields from '../../../../../../../../../components/FastCash/EditCashbackFormFields';
import { StoreProvider } from '../../../../../../../../../components';

const EditCashbackFormView = (props) => {
  const { values, setFieldValue, errors, onModalClose, lists, handleSubmit } =
    props;
  const stores = lists.stores.edges.map((e) => e.node);

  const handleChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  const handleDateChange = (newDate) => {
    const formattedDate = DatePresenter.shortFormattedDate(newDate);
    setFieldValue('date', formattedDate);
  };

  return (
    <div className="cashbacks" onSubmit={handleSubmit}>
      <form className="create-cashback-form">
        <EditCashbackFormFields
          values={values}
          stores={stores}
          onChange={handleChange}
          onDateChange={handleDateChange}
          errors={errors}
        />
        <div className="modal-actions">
          <button className="modal-save" type="submit">
            Save Changes
          </button>
          <button className="modal-close" onClick={onModalClose}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

const EditCashbackFormContainer = createFragmentContainer(
  EditCashbackFormView,
  {
    lists: graphql`
      fragment EditCashbackForm_lists on Lists {
        stores(first: 1000, active: false) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  }
);

const EditCashbackForm = (props) => {
  return (
    <StoreProvider
      container={EditCashbackFormContainer}
      modern
      query={graphql`
        query EditCashbackFormQuery {
          lists {
            ...EditCashbackForm_lists
          }
        }
      `}
      {...props}
    />
  );
};

export default EditCashbackForm;

EditCashbackFormView.propTypes = {
  lists: PropTypes.shape({
    stores: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: StorePresenter.shape().isRequired,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  values: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
};
